import { tokens as emojiListTokens } from '../EmojiList/tokens';

const outerPadding = 16;

const totalEmojiRowHeight = emojiListTokens.emoji.size * emojiListTokens.list.rows;
const totalEmojiGapHeight = emojiListTokens.list.gap * (emojiListTokens.list.rows - 1);
const totalEmojiListPaddingHeight = outerPadding + outerPadding / 2;

export const tokens = {
    common: {
        padding: outerPadding,
    },
    mainSection: {
        scrollableHeight: totalEmojiRowHeight + totalEmojiGapHeight + totalEmojiListPaddingHeight,
    },
    nav: {
        list: {
            columns: 7,
            gap: outerPadding / 2,
        },
        item: {
            size: 32,
        },
        icon: {
            size: 20,
        },
        getTotalWidth() {
            // The current column count of `7` is a specific subset
            // of the existing "emoji categories" that are supported
            // within a Yat. If other categories are added in the future,
            // we will need to update this value.

            const totalItemWidth = this.list.columns * this.item.size;
            const totalGapWidth = this.list.gap * (this.list.columns - 1);
            const totalGutterWidth = this.list.gap * 2;

            return totalItemWidth + totalGapWidth + totalGutterWidth;
        },
    },
    search: {
        paddingX: 20,
        paddingY: 6,
    },
};
